import SEO from '../components/SEO';
import { PageHero } from '../components/Reveal';
import CareerExplorer from '../components/home/CareerExplorer';
import FinalCTA from '../components/home/FinalCTA';

const CareerPaths = () => (
  <main data-testid="career-paths-page">
    <SEO
      title="Explore Career Paths — AI, Software, Finance, Design & More | CareerWithRaaj"
      description="Explore 13 career categories with real details: who each career suits, key skills, recommended courses, and career progression. AI career roadmap, data science, finance, design and more."
    />
    <PageHero
      overline="Career Paths"
      title="Thirteen Fields. One That's Yours."
      description="Each career below shows who it suits, the skills it needs, the courses that get you there, and how it grows. No hype — just clear, honest maps."
    />
    <CareerExplorer />
    <FinalCTA />
  </main>
);

export default CareerPaths;
